import React from "react";
import { MainContent } from "../MainContent/MainContent";
import { Routes, Route } from "react-router-dom";
import axios from "axios";
import { useEffect, useState } from "react";
import { Post } from "../MainContent/Post";
import { Support } from "./Support";
import { Service } from "./Service";
import { Tictac } from "./Tictac";
import { Contact } from "./Contact";
import Story from "./Story";
import AboutMe from "./AboutMe";
import Samples from "../Samples/Samples";
import severUrl from "../../api";
import { SettingPage } from "./SettingPage";
import ASR from "./ASR";
import CV from "./CV";
import NLP from "./NLP";
import Disclaimer from "../Footer/Disclaimer";
import Privacy from "../Footer/Privacy";
import Terms from "../Footer/Terms";
import useViewport from "../Utils/useViewPort";
import { MobilePost } from "../MainContent/MobilePost";
import { Coffe } from "./Coffe";
import { MyEditor } from "../Admin/MyEditor";
import { Update } from "./Update";
import blur from "../../assets/images/bluur.png"
import RightPanel from "../RightPanel/RightPanel";
import LeftPanel from "../LeftPanel/LeftPanel";
import { DummyItem } from "../Search/DummyItem";
import  SearchContent from "../MainContent/SearchContent";
// const HeavyComponent = lazy(() => import('../MainContent/MobilePost'));

const useCheckMobileScreen = () => {
  const [width, setWidth] = useState(window.innerWidth);
  const handleWindowSizeChange = () => {
          setWidth(window.innerWidth);
  }

  useEffect(() => {
      window.addEventListener('resize', handleWindowSizeChange);
      return () => {
          window.removeEventListener('resize', handleWindowSizeChange);
      }
  }, []);

  return (width <= 768);
}

export default useCheckMobileScreen

const Dummy = () => {
  return (
    <>
      <div>
        <div className="Head-post">
          <p className="title">Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas.</p>
        </div>
        <img style={{ width: "100%" }} src={blur} />
        <p>Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Vestibulum tortor quam, feugiat vitae, ultricies eget, tempor sit amet, ante. Donec eu libero sit amet quam egestas semper. Aenean ultricies mi vitae est. Mauris placerat eleifend leo. Quisque sit amet est et sapien ullamcorper pharetra. Vestibulum erat wisi, condimentum sed, commodo vitae, ornare sit amet, wisi. Aenean fermentum, elit eget tincidunt condimentum, eros ipsum rutrum orci, sagittis tempus lacus enim ac dui. Donec non enim in turpis pulvinar facilisis. Ut felis. Praesent dapibus, neque id cursus faucibus, tortor neque egestas augue, eu vulputate magna eros eu erat. Aliquam erat volutpat. Nam dui mi, tincidunt quis, accumsan porttitor, facilisis luctus, metus</p>
        <p>Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Vestibulum tortor quam, feugiat vitae, ultricies eget, tempor sit amet, ante. Donec eu libero sit amet quam egestas semper. Aenean ultricies mi vitae est. Mauris placerat eleifend leo. Quisque sit amet est et sapien ullamcorper pharetra. Vestibulum erat wisi, condimentum sed, commodo vitae, ornare sit amet, wisi. Aenean fermentum, elit eget tincidunt condimentum, eros ipsum rutrum orci, sagittis tempus lacus enim ac dui. Donec non enim in turpis pulvinar facilisis. Ut felis. Praesent dapibus, neque id cursus faucibus, tortor neque egestas augue, eu vulputate magna eros eu erat. Aliquam erat volutpat. Nam dui mi, tincidunt quis, accumsan porttitor, facilisis luctus, metus</p>
        <p>Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Vestibulum tortor quam, feugiat vitae, ultricies eget, tempor sit amet, ante. Donec eu libero sit amet quam egestas semper. Aenean ultricies mi vitae est. Mauris placerat eleifend leo. Quisque sit amet est et sapien ullamcorper pharetra. Vestibulum erat wisi, condimentum sed, commodo vitae, ornare sit amet, wisi. Aenean fermentum, elit eget tincidunt condimentum, eros ipsum rutrum orci, sagittis tempus lacus enim ac dui. Donec non enim in turpis pulvinar facilisis. Ut felis. Praesent dapibus, neque id cursus faucibus, tortor neque egestas augue, eu vulputate magna eros eu erat. Aliquam erat volutpat. Nam dui mi, tincidunt quis, accumsan porttitor, facilisis luctus, metus</p>
        <p>Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Vestibulum tortor quam, feugiat vitae, ultricies eget, tempor sit amet, ante. Donec eu libero sit amet quam egestas semper. Aenean ultricies mi vitae est. Mauris placerat eleifend leo. Quisque sit amet est et sapien ullamcorper pharetra. Vestibulum erat wisi, condimentum sed, commodo vitae, ornare sit amet, wisi. Aenean fermentum, elit eget tincidunt condimentum, eros ipsum rutrum orci, sagittis tempus lacus enim ac dui. Donec non enim in turpis pulvinar facilisis. Ut felis. Praesent dapibus, neque id cursus faucibus, tortor neque egestas augue, eu vulputate magna eros eu erat. Aliquam erat volutpat. Nam dui mi, tincidunt quis, accumsan porttitor, facilisis luctus, metus</p>
        <p>Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Vestibulum tortor quam, feugiat vitae, ultricies eget, tempor sit amet, ante. Donec eu libero sit amet quam egestas semper. Aenean ultricies mi vitae est. Mauris placerat eleifend leo. Quisque sit amet est et sapien ullamcorper pharetra. Vestibulum erat wisi, condimentum sed, commodo vitae, ornare sit amet, wisi. Aenean fermentum, elit eget tincidunt condimentum, eros ipsum rutrum orci, sagittis tempus lacus enim ac dui. Donec non enim in turpis pulvinar facilisis. Ut felis. Praesent dapibus, neque id cursus faucibus, tortor neque egestas augue, eu vulputate magna eros eu erat. Aliquam erat volutpat. Nam dui mi, tincidunt quis, accumsan porttitor, facilisis luctus, metus</p>
        <p>Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Vestibulum tortor quam, feugiat vitae, ultricies eget, tempor sit amet, ante. Donec eu libero sit amet quam egestas semper. Aenean ultricies mi vitae est. Mauris placerat eleifend leo. Quisque sit amet est et sapien ullamcorper pharetra. Vestibulum erat wisi, condimentum sed, commodo vitae, ornare sit amet, wisi. Aenean fermentum, elit eget tincidunt condimentum, eros ipsum rutrum orci, sagittis tempus lacus enim ac dui. Donec non enim in turpis pulvinar facilisis. Ut felis. Praesent dapibus, neque id cursus faucibus, tortor neque egestas augue, eu vulputate magna eros eu erat. Aliquam erat volutpat. Nam dui mi, tincidunt quis, accumsan porttitor, facilisis luctus, metus</p>
        <p>Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Vestibulum tortor quam, feugiat vitae, ultricies eget, tempor sit amet, ante. Donec eu libero sit amet quam egestas semper. Aenean ultricies mi vitae est. Mauris placerat eleifend leo. Quisque sit amet est et sapien ullamcorper pharetra. Vestibulum erat wisi, condimentum sed, commodo vitae, ornare sit amet, wisi. Aenean fermentum, elit eget tincidunt condimentum, eros ipsum rutrum orci, sagittis tempus lacus enim ac dui. Donec non enim in turpis pulvinar facilisis. Ut felis. Praesent dapibus, neque id cursus faucibus, tortor neque egestas augue, eu vulputate magna eros eu erat. Aliquam erat volutpat. Nam dui mi, tincidunt quis, accumsan porttitor, facilisis luctus, metus</p>
        <p>Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Vestibulum tortor quam, feugiat vitae, ultricies eget, tempor sit amet, ante. Donec eu libero sit amet quam egestas semper. Aenean ultricies mi vitae est. Mauris placerat eleifend leo. Quisque sit amet est et sapien ullamcorper pharetra. Vestibulum erat wisi, condimentum sed, commodo vitae, ornare sit amet, wisi. Aenean fermentum, elit eget tincidunt condimentum, eros ipsum rutrum orci, sagittis tempus lacus enim ac dui. Donec non enim in turpis pulvinar facilisis. Ut felis. Praesent dapibus, neque id cursus faucibus, tortor neque egestas augue, eu vulputate magna eros eu erat. Aliquam erat volutpat. Nam dui mi, tincidunt quis, accumsan porttitor, facilisis luctus, metus</p>
      </div>
    </>
  )
}

// https://codesandbox.io/p/sandbox/todo-app-with-redux-itg60?file=%2Fsrc%2Fcomponents%2FVisibilityFilters.js%3A11%2C48

export const MainView = (props) => {

  const [slugs, setSlugs] = useState(null);
  const [visible, setVisible] = useState("hidden");
  const [display, setDisplay] = useState("block");
  const [pload, setPload] = useState("none");
  const [reload, setReload] = useState("none");
  const [apiError, setAPIError] = useState(false)



  useEffect(() => {
    axios.get(severUrl + `blog/get/slug/all/`).then((response) => {
      // console.log(response.data.slugs)
      setSlugs(response.data.slugs);
      setDisplay("none");
    }).catch( (error) => {
      setReload("block")
      setDisplay("none");
      setAPIError(true)
    })
  }, []);

  const viewPort = useViewport();
  const isMobile = viewPort.width <= 1024;

  useEffect(() => {
    return () => {
      localStorage.removeItem("key");
    };
  });

  const handleDataFromChild = () => {
    setVisible("visible");
    setDisplay("none");
    setPload(true);
  };

  const handleDataChild = () => {
    setVisible("visible");
    setDisplay("none");
    setPload(true);
  };

  return (
    <>
      <div
        className="mainview"
        style={{
          display: isMobile ? "block" : "grid",
          gridGap: "10px",
          gridTemplateAreas: "LeftPanel MainContent RightPanel",
          gridAutoColumns: "1fr",
          gridAutoFlow: "column",
          paddingLeft: isMobile ? "10px" : "none",
        }}
      >

        {!isMobile && <LeftPanel slug={props.slug} />}

        {isMobile && (<>
                        <div
                        style={{
                          display: display,
                          maxWidth: "100%",
                          width: "100%",
                          filter: "blur(8px)"
                        }}>
                        <DummyItem />
                        <DummyItem />
                        <DummyItem />
                        <DummyItem />
                        <DummyItem />
                      </div></>)}

        <Routes forceRefresh={true}>
          {slugs ? (
            slugs.map((slug) => (
              <Route
                path={"/" + slug}
                element={
                  <MainContent
                    slug={slug}
                    pload={pload}
                    sendData={handleDataChild} 
                    apiError={apiError}
                    post={
                      isMobile ? (<>
                        <div
                          style={{
                            display: display,
                            maxWidth: "100%",
                            width: "100%",
                            filter: "blur(8px)"
                          }}>
                          <DummyItem />
                          <DummyItem />
                          <DummyItem />
                          <DummyItem />
                          <DummyItem />
                        </div>

                        <span visibility={visible} >
                          <MobilePost data={{ slug: slug }} sendDataToParent={handleDataFromChild} />
                        </span>

                        </>
                      ) : (
                        <>
                          <div
                            style={{
                              display: display,
                              gridArea: "MainContent",
                              gridColumn: "6/30",
                              maxWidth: "100%",
                              width: "100%",
                              filter: "blur(8px)"
                            }}>
                            <Dummy />
                          </div>
                          <span visibility={visible} >
                            <Post data={{ slug: slug }} sendDataToParent={handleDataFromChild} /> 
                          </span>
                          </>
                      )
                    }
                  />
                }
              />
            ))




          ) : (
            <></>
          )}
          <Route path={"/"} element={<MainContent  apiError={apiError} />} />
          <Route path={"/search"} element={<SearchContent />} />
          <Route path="/home" element={<MainContent   apiError={apiError}/>}></Route>
          <Route path="/editor" element={<MyEditor />}></Route>
          <Route
            path="/account"
            element={<MainContent content={<SettingPage />} />}
          ></Route>
          <Route
            path="/support"
            element={<MainContent content={<Support />} />}
          ></Route>
          <Route
            path="/Coffee"
            element={<MainContent content={<Coffe />} />}
          ></Route>
          <Route
            path="/service"
            element={<MainContent content={<Service />} />}
          ></Route>
          <Route
            path="/contact"
            element={<MainContent content={<Contact />} />}
          ></Route>
          <Route
            path="/about"
            element={<MainContent content={<AboutMe />} />}
          ></Route>
          <Route
            path="/terms"
            element={<MainContent content={<Terms />} />}
          ></Route>
          <Route
            path="/privacy"
            element={<MainContent content={<Privacy />} />}
          ></Route>
          <Route
            path="/disclaimer"
            element={<MainContent content={<Disclaimer />} />}
          ></Route>
          <Route
            path="/sample"
            element={<MainContent content={<Samples />} />}
          ></Route>
          <Route
            path="/update"
            element={<MainContent content={<Update />} />}
          ></Route>
          <Route
            path="/tictac"
            element={<MainContent content={<Tictac />} />}
          ></Route>
          <Route
            path="/Story"
            element={<MainContent content={<Story />} />}
          ></Route>
          <Route path="/cv" element={<MainContent content={<CV />} />}></Route>
          <Route
            path="/nlp"
            element={<MainContent content={<NLP />} />}
          ></Route>
          <Route
            path="/asr"
            element={<MainContent content={<ASR />} />}
          ></Route>
        </Routes>
        {!isMobile && <RightPanel />}

      </div>
    </>
  );
};
